import Vue from "vue";
import {Ticket} from "@/models/ticket";
import {Axios} from "@/services/auth-service";
import {TicketReplyTemplate} from "@/models/ticket-reply-template";
import {Admin} from "@/models/admin";
import {ServerConfig} from "@/config/config";

const EMAIL_TEMPLATE_STORE = `https://hook.integromat.com/2ckpqxybkefe87w07umf11ksyv7hs4iu`;
//const AUTO_EMAIL_HOOK = `https://hook.integromat.com/xnly3gd8aj5y71w9615821y3nfbjnd9l`;
//const AUTO_EMAIL_HOOK = `https://winfakt.app:5678/webhook/c46abcd1-55b3-4cf0-803e-bf16ce1614cb`;

const N8N_HOOK_URL = `${ServerConfig.host}/admin/n8n/trigger-hook`;

export const IntegromatService = new Vue({

	methods: {

		async getAutoEmailTemplates() {

			let result = await Axios.get(EMAIL_TEMPLATE_STORE);
			return Object(result.data).map((t: any) => new TicketReplyTemplate({
				triggerHook: true,
				eventId: t.id,
				name: t.subject
			}));

		},

		async triggerAutoEmailHook(ticket: Ticket, email: string, eventId: number, admin: Admin) {

			await Axios.post(N8N_HOOK_URL+"/c46abcd1-55b3-4cf0-803e-bf16ce1614cb", {
				ticketId: ticket.id,
				email,
				id: eventId,
				admin,
				client: ticket.client ? ticket.client : []
			});

		}

	}

});